import { GET_POST, GET_REPOST } from '@/constants/api'
import { generalAxiosInstance } from '@/utils/request'
import {
	normalizePublicPostError,
	parsePublicPostSnapshot,
	type PublicPostSnapshot,
} from '@/utils/webmcp/getPostContract'
import { parsePublicRepostSnapshot } from '@/utils/webmcp/getRepostContract'

interface GetPostResponse {
	data: unknown
}

export async function fetchPublicOriginalPost(
	id: string,
	signal?: AbortSignal
): Promise<PublicPostSnapshot> {
	try {
		const response = await generalAxiosInstance.get<GetPostResponse>(GET_POST, {
			params: { id },
			signal,
			withCredentials: false,
		})

		return parsePublicPostSnapshot(response.data.data, id)
	} catch (error) {
		throw normalizePublicPostError(error)
	}
}

export async function fetchPublicRepost(id: string, signal?: AbortSignal) {
	try {
		const response = await generalAxiosInstance.get<GetPostResponse>(GET_REPOST, {
			params: { id },
			signal,
			withCredentials: false,
		})

		return parsePublicRepostSnapshot(response.data.data, id)
	} catch (error) {
		throw normalizePublicPostError(error)
	}
}
